import { Button, ButtonGroup, Offcanvas } from 'react-bootstrap';

import { useDonationContextProvider } from 'context/DonationContextProvider';

import IconButton from '../common/IconButton';
import { formatMoney } from 'helpers/utils';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CartDrawer() {
  const {
    basket,
    decreaseDonationCount,
    increaseDonationCount,
    isCartDrawerOpen,
    setIsCartDrawerOpen,
    setIsGiftAidDrawerOpen,
    transactionFeeAmount,
    subtotal,
    totalAmount,
    transactionFee,
    removeDonation
  } = useDonationContextProvider();

  const onAddAnotherDonation = () => {
    // setIsCartDrawerOpen(false);
    // if (isPackageDrawerOpen) {
    //   setIsPackageDrawerOpen(false);
    // }
    // if (isGiftAidDrawerOpen) {
    //   setIsGiftAidDrawerOpen(false);
    // }
    setIsCartDrawerOpen(false);
  };

  // let rightPosition = 0;
  // let drawerWidth = '500px';
  // if (isGiftAidDrawerOpen) {
  //   drawerWidth = '400px';
  //   rightPosition = '400px';
  // }

  return (
    <Offcanvas
      show={isCartDrawerOpen}
      onHide={() => setIsCartDrawerOpen(false)}
      placement="end"
      backdrop={true}
      className="bg-wr-donation-grey-50"
      style={{ width: '90%', maxWidth: 500 }}
    >
      <Offcanvas.Header>
        {/*{!isPackageDrawerOpen && (*/}
        <Button
          className="bg-transparent shadow-none border-0 fs-2 p-0 text-danger"
          onClick={() => {
            setIsCartDrawerOpen(false);
            // if (isGiftAidDrawerOpen) {
            //   setIsGiftAidDrawerOpen(false);
            // }
          }}
        >
          &times;
        </Button>
        {/*)}*/}
      </Offcanvas.Header>
      <Offcanvas.Body>
        <h2 className="text-uppercase wr-donation-header2 wr-donation-cart-header pb-3 mb-4">
          DONATION ADDED
        </h2>

        {basket.length === 0 && (
          <p className="wr-donation-body2 text-uppercase text-center my-10">
            Your basket is empty
          </p>
        )}
        {basket.length > 0 && (
          <div className="d-flex flex-column gap-3">
            {basket.map(item => (
              <div
                key={item.id}
                className="wr-donation-summary-card d-flex flex-column gap-2"
              >
                <header className="d-flex justify-content-between align-items-center wr-donation-text-brand-secondary">
                  <h3 className="text-capitalize mb-0 fw-semi-bold">
                    {item.packageId ? item.packageName : 'Quick Donation'}
                  </h3>

                  <div className="d-flex align-items-center gap-2">
                    <span className="fs-2 fw-semi-bold">
                      {formatMoney(item.count * item.donationAmount.value, '£')}
                    </span>
                  </div>
                </header>
                <ul>
                  <li>{item.paymentType.charAt(0).toUpperCase() + item.paymentType.slice(1)}</li>
                  <li>{item.donationType.name}</li>
                </ul>
                <hr className="my-0" />
                <div className="d-flex justify-content-between align-items-center">
                  <ButtonGroup className="align-self-start wr-donation-border-primary">
                    <Button
                      variant="text"
                      className="wr-donation-border-primary"
                      onClick={() => decreaseDonationCount(item.id, 1)}
                    >
                      -
                    </Button>
                    <Button
                      variant="text"
                      className="text-black wr-donation-border-primary"
                    >
                      {item.count}
                    </Button>
                    <Button
                      variant="text"
                      className="wr-donation-border-primary"
                      onClick={() => increaseDonationCount(item.id, 1)}
                    >
                      +
                    </Button>
                  </ButtonGroup>
                  <Button
                    variant="link"
                    className="p-0 text-danger"
                    onClick={() => removeDonation(item.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </div>
              </div>
            ))}
            <div className="wr-donation-summary-card d-flex flex-column gap-3">
              <header className="wr-donation-text-brand-secondary fw-bold d-flex justify-content-between align-items-center">
                <span>Subtotal</span>
                <span>{formatMoney(subtotal, '£')}</span>
              </header>
              <header className="wr-donation-text-brand-secondary fw-bold d-flex justify-content-between align-items-center">
                <span>Transaction Fee</span>
                <span>
                  {formatMoney(transactionFee ? transactionFeeAmount : 0, '£')}
                </span>
              </header>
              <header className="wr-donation-text-brand-secondary fw-bold d-flex justify-content-between align-items-center">
                <span>Total</span>
                <span>{formatMoney(totalAmount, '£')}</span>
              </header>
            </div>
            <IconButton
              className="py-3 text-dark fw-medium"
              style={{ backgroundColor: '#FFD75E', border: 'none' }}
              icon="hand-holding-heart"
              iconAlign="right"
              iconClassName="text-dark ms-2"
              onClick={onAddAnotherDonation}
            >
              Add Another Donation
            </IconButton>
            <Button
              className="border-0 bg-wr-donation-primary py-3"
              onClick={() => {
                setIsCartDrawerOpen(false);
                setIsGiftAidDrawerOpen(true);
              }}
            >
              Checkout &gt;
            </Button>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

CartDrawer.propTypes = {};

export { CartDrawer };
